<template>
  <div class="four wide column">
    <div class="listing-buttons">
      <button class="ui primary button right floated" @click="add(route)">Add {{name}}</button>
      <!-- <button class="ui button secondary column" @click="edit">Edit {{name}}</button>
      <button class="ui button column" @click="remove">Delete {{name}}</button>-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    name: {
      type: String
    },
    route: {
      type: String
    }
  },
  methods: {
    add(route) {      
      this.$router.push({
        name: route,
      });
    },
    edit() {
      // console.log("edit");
    },
    remove() {
      // console.log("remove");
    }
  }
};
</script>